// Echological.fm - Refined animations and interactions
// Reveal observer for scroll animations
const revealObserver = new IntersectionObserver((entries)=>{
    entries.forEach((entry)=>{
        if (entry.isIntersecting) {
            entry.target.classList.add('visible');
            revealObserver.unobserve(entry.target);
        }
    });
}, {
    threshold: 0.1,
    rootMargin: '0px 0px -50px 0px'
});
document.addEventListener('DOMContentLoaded', ()=>{
    // Observe all reveal elements
    document.querySelectorAll('.reveal').forEach((el)=>{
        revealObserver.observe(el);
    });
    // Smooth scroll for anchor links
    document.querySelectorAll('a[href^="#"]').forEach((anchor)=>{
        anchor.addEventListener('click', function(e) {
            e.preventDefault();
            const target = document.querySelector(this.getAttribute('href'));
            if (target) {
                target.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
                const navMenu = document.querySelector('.nav-menu');
                const hamburger = document.querySelector('.hamburger');
                if (navMenu && hamburger) {
                    navMenu.classList.remove('active');
                    hamburger.classList.remove('active');
                }
            }
        });
    });
    // Hamburger menu toggle
    const hamburger = document.querySelector('.hamburger');
    const navMenu = document.querySelector('.nav-menu');
    if (hamburger && navMenu) hamburger.addEventListener('click', ()=>{
        hamburger.classList.toggle('active');
        navMenu.classList.toggle('active');
    });
});
// Nav scroll state
const nav = document.querySelector('.nav');
if (nav) window.addEventListener('scroll', ()=>{
    nav.classList.toggle('scrolled', window.scrollY > 80);
});

//# sourceMappingURL=echologicalfm.740196e5.js.map
